@if(selectedVehicle){
  <div class="selected-vehicle-btn-wrapper" [class.disabled]="disabled">
    <button (click)="!disabled && showAddVehicleDialog()" pButton pRipple class="current-vehicle-btn pl-unset">
      <div class="car-img-wrapper">
        <img class="check-circle" src="./../../../../../assets/images/icons/check_circle.svg" alt="check-circle">
        <img class="car-icon" src="./../../../../../assets/images/icons/navigation/car.svg" alt="car">
      </div>
      <span class="inner-label">
        {{selectedVehicle?.year}} {{selectedVehicle?.details?.manufacturer?.name}}
        {{selectedVehicle?.details?.model?.name}} {{selectedVehicle?.details?.modification?.name}}
      </span>
      <img class="arrow-icon" src="./../../../../../assets/images/icons/navigation/arrow_forward_ios.svg" alt="arrow">
    </button>
  </div>
} @else {
  <div class="add-vehicle-btn-wrapper" [class.disabled]="disabled">
    <button (click)="!disabled && showAddVehicleDialog()" pButton pRipple class="add-vehicle-btn">
      <img class="car-icon" src="./../../../../../assets/images/icons/navigation/car.svg" alt="car">
      <span class="inner-label">Add Vehicle</span>
      <img class="arrow-icon" src="./../../../../../assets/images/icons/navigation/arrow_forward_ios.svg" alt="arrow">
    </button>
  </div>
}

